var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.19557C3.01035 3.24202 4.43719 2.58386 5.92194 2.27113C7.25833 1.98964 8.68555 1.8891 10.0375 2.15535C10.9997 2.34484 11.7506 2.75673 12.5105 3.25908C13.3927 3.84221 14.2191 4.35246 15.3115 4.65353C16.7827 5.059 18.2773 5.08717 19.7924 4.84906C21.9302 4.51308 23.92 3.76546 26 3.26937",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.6148C3.01035 11.6612 4.43719 11.003 5.92194 10.6903C7.25833 10.4088 8.68555 10.3083 10.0375 10.5745C10.9997 10.764 11.7506 11.1759 12.5105 11.6783C13.3927 12.2614 14.2191 12.7717 15.3115 13.0727C16.7827 13.4782 18.2773 13.5064 19.7923 13.2682C21.9302 12.9323 23.92 12.1846 26 11.6886",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 21.0339C3.01035 20.0804 4.43719 19.4222 5.92194 19.1095C7.25833 18.828 8.68555 18.7275 10.0375 18.9937C10.9997 19.1832 11.7506 19.5951 12.5105 20.0975C13.3927 20.6806 14.2191 21.1908 15.3115 21.4919C16.7827 21.8974 18.2773 21.9255 19.7924 21.6874C21.9302 21.3515 23.92 20.6038 26 20.1077",
    strokeWidth: 3,
    strokeMiterlimit: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.28181ddb.svg";
export { ForwardRef as ReactComponent };